// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3r4P5","head":"Table_head__4LUjS","col":"Table_col__3uG0g"};